<pw-file-input multiple="false" (filesChanged)="onFilesChanged($event)"></pw-file-input>

<div class="ps-grid-2-col">
  <button mat-button color="primary" (click)="save()">
    SPEICHERN
  </button>
  <button mat-button color="primary" (click)="dismiss()">
    ABBRECHEN
  </button>
</div>
